import { useUserActivity } from "@/features/user_activity/useUserActivity";

export const userActivity = useUserActivity();
